import { getIsAuthView, getPreAuthPath, setPreAuthPath } from '@/services/auth.ts'

const BASE_URL_KEY = 'base-url'

export function redirect (): void {
    if (getIsAuthView()) return

    const preAuthPath = getPreAuthPath()
    if (!preAuthPath) return

    const baseUrl = localStorage.getItem(BASE_URL_KEY) ??
        window.location.origin
    // Crude way of preventing external redirect attacks
    const finalPath = `${baseUrl}/${preAuthPath.slice(1)}`

    setPreAuthPath(null)
    if (window.location.href === finalPath) return

    window.location.replace(finalPath)
}

export function save (path: string): void {
    setPreAuthPath(path)
}
